import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useAuth } from '../../../shared/ui';
import { completeEmailSignIn } from '../../../shared/utils/firebase';

export const EmailLinkCallbackPage = () => {
  const { socialLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const idToken = await completeEmailSignIn(window.location.href);
        if (!idToken) {
          setError(
            'This link is not a valid sign-in link. Please request a new one.'
          );
          return;
        }
        const success = await socialLogin(idToken);
        if (success) {
          navigate({ to: '/' });
        } else {
          setError('Sign-in failed. Please try again.');
        }
      } catch (err) {
        setError(
          err instanceof Error ? err.message : 'An unexpected error occurred.'
        );
      }
    };

    handleCallback();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
      }}
    >
      {error ? (
        <>
          <Typography variant="h6" color="error">
            Sign-in failed
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {error}
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress sx={{ color: '#3d98ff' }} />
          <Typography variant="body1" color="text.secondary">
            Completing sign-in&hellip;
          </Typography>
        </>
      )}
    </Box>
  );
};
